/*
 * Module Comment
*/

rs.module("security/listings/portalactivityinspector",

    [],

    function () {

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrls) {

            var form = $.js(jsSelectors.form);
            var inspectButton = form.js(jsSelectors.inspectButton);

            var siteSelect = form.js(jsSelectors.siteSelect);
            var fromDate = form.js(jsSelectors.fromDate);
            var toDate = form.js(jsSelectors.toDate);

            inspectButton.on("click", function (e) {
                if (form.valid()) {

                    inspectButton.setDisabled(true).togglePulse(true);

                    // make the call to get suspicious portal activity
                    $.ajax({
                        type: "POST",
                        url: backendUrls.inspectActivity,
                        data: {
                            siteID: siteSelect.val(),
                            fromDate: fromDate.val(),
                            toDate: toDate.val()
                        }
                    })
                    .done(function(html) {
                        $.js(jsSelectors.resultsDiv).html(html);
                    })
                    .fail(function() {
                        $.js(jsSelectors.resultsDiv).empty();
                    })
                    .always(function() {
                        inspectButton.setDisabled(false).togglePulse(false);
                    });
                }
            });

        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);